export var calculateProgress = function (swiperInstance) {
    if (swiperInstance.slides.length > 1) {
        return (swiperInstance.realIndex / (swiperInstance.slides.length - 1)) * 100;
    }
    return 0;
};
